<template>
  <div class="news-index container">
    <h1 class="nav-title">{{ $t("nav.news") }}</h1>
    <cpo-news-list :items="items" />
  </div>
</template>

<script>
import CpoNewsList from "@/components/CpoNewsList.vue";
export default {
  components: { CpoNewsList },
  data() {
    return {
      categories: [{ text: "乐团新闻", value: "1edc0466-42bd-56bf-953a-124acbe34" }],
      items: []
    };
  },
  created() {
    this.$axios
      .post("/news/category", {})
      .then((data) => {
        this.categories = data.map((c) => {
          return { text: c.name, value: c.id };
        });
        return this.$axios.post("/news/list", { filter: [], sort: [{ field: "date", asc: false }] });
      })
      .then((data) => {
        this.items = data.map((item) => {
          item.category = this.categories.find((c) => c.value == item.category);
          return item;
        });
      });
  },
  methods: {}
};
</script>

<style lang="scss">
</style>
